import { useQuery } from "@tanstack/react-query";

import type { IntentTaxonomyDescriptionDto } from "app/pages/sales-intelligence/domain/intent/types/dto";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { intentQueryKeys } from "./queryKeyFactory";

const STALE_TIME_MS = 5 * 60 * 1000;

type UseIntentTaxonomyDescriptionQueryOptions = {
    enabled?: boolean;
};

export default function useIntentTaxonomyDescriptionQuery({
    enabled = true,
}: UseIntentTaxonomyDescriptionQueryOptions = {}) {
    return useQuery<IntentTaxonomyDescriptionDto>({
        queryKey: intentQueryKeys.taxonomyDescription(),
        queryFn: ({ signal }) => salesApiService.intent.fetchTaxonomyDescription({ cancellation: signal }),
        enabled,
        staleTime: STALE_TIME_MS,
    });
}
